import { logger } from '@pkg/logger';
import { defineNuxtPlugin } from 'nuxt/app';

/** Consola log level (see https://github.com/unjs/consola#log-level). `info` is 3. */
function coerceLogLevel(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number.parseInt(value, 10);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

export default defineNuxtPlugin({
  name: 'logger',
  setup(nuxtApp) {
    const runtimeConfig = useRuntimeConfig();
    const fromPublic = coerceLogLevel(runtimeConfig.public.logLevel);
    // Default 3 = show `logger.info`. Use NUXT_PUBLIC_LOG_LEVEL=1 or 2 for quieter production builds.
    logger.level = fromPublic ?? 3;

    try {
      nuxtApp.vueApp.config.errorHandler = (error, context) => {
        logger.error('logger.ts', error);

        // This will trigger a Vue Warn in development "Avoid app logic that relies on enumerating keys on a component instance."
        // This is fine, we can ignore the warning when looking for the error.
        logger.debug('logger.ts', context);
      };
    } catch (error) {
      logger.error('logger.ts', error);
    }
  },
});
